var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNajaSetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0.999999C5.05 0.999999 1 5.05 1 10C1 14.95 5.05 19 10 19C14.95 19 19 14.95 19 10C19 5.05 14.95 1 10 0.999999Z",
    fill: "white",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 13.5996L10 9.09961",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0039 6.40039L9.99582 6.40039L10.0039 6.40039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 6.40039L9.99582 6.40039",
    stroke: "#0008C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNajaSetIcon);
export default __webpack_public_path__ + "static/media/naja_set_icon.f038b9fd3b657932034571c55a10b5d8.svg";
export { ForwardRef as ReactComponent };